import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StatusBadge, Money } from "@/components/shared/Common";

export default function DoctorEarnings() {
  const [earn, setEarn] = useState(null);
  useEffect(() => { api.get("/doctor/earnings").then(r => setEarn(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div><div className="cm-eyebrow mb-2">Earnings</div><h1 className="cm-h2">Your payouts</h1></div>
      <div className="grid md:grid-cols-4 gap-4">
        <Stat label="Total paid" value={<Money amount={earn?.total_paid || 0}/>}/>
        <Stat label="Pending" value={<Money amount={earn?.pending_amount || 0}/>}/>
        <Stat label="Completed consults" value={earn?.completed_count || 0}/>
        <Stat label="Paid consults" value={earn?.paid_count || 0}/>
      </div>
      <div className="cm-card divide-y divide-[#e2e8f0]" data-testid="dr-earnings-list">
        <div className="pb-3 font-semibold text-[#1a2b4a]">Recent activity</div>
        {(earn?.recent || []).map(a => (
          <div key={a.id} className="py-3 flex items-center justify-between">
            <div>
              <div className="text-sm font-medium text-[#1a2b4a] capitalize">{a.consultation_type} · {(a.slot_datetime||"").slice(0,10)}</div>
              <div className="text-xs text-[#475569]">{a.reason || "General consultation"}</div>
            </div>
            <div className="flex items-center gap-3">
              <StatusBadge status={a.status}/>
              <div className="text-sm font-semibold text-[#1a2b4a]"><Money amount={a.doctor_payout} currency={a.currency}/></div>
            </div>
          </div>
        ))}
        {(!earn?.recent || earn.recent.length === 0) && <div className="py-3 text-sm text-[#475569]">No consultations yet.</div>}
      </div>
    </div>
  );
}
const Stat = ({ label, value }) => (
  <div className="cm-card">
    <div className="text-xs uppercase tracking-wider text-[#4a90d9] font-semibold">{label}</div>
    <div className="text-2xl font-bold text-[#1a2b4a] mt-1">{value}</div>
  </div>
);
